import { z } from "zod";

import type { AttemptResult } from "../contracts";
import {
  difficultySchema,
  domainSchema,
  entityIdSchema,
  hasUniqueValues,
  isLevelIdFor,
  levelIdSchema,
  nonNegativeSafeIntegerSchema,
  timestampSchema
} from "./common";

export const attemptResultSchema = z
  .strictObject({
    id: entityIdSchema,
    profileId: entityIdSchema,
    levelId: levelIdSchema,
    domain: domainSchema,
    difficulty: difficultySchema,
    correctRate: z.number().min(0).max(1),
    hintCount: nonNegativeSafeIntegerSchema,
    retryCount: nonNegativeSafeIntegerSchema,
    durationMs: nonNegativeSafeIntegerSchema,
    completedAt: timestampSchema
  })
  .superRefine((attempt, context) => {
    if (
      !isLevelIdFor(attempt.levelId, attempt.domain, attempt.difficulty)
    ) {
      context.addIssue({
        code: "custom",
        path: ["levelId"],
        message: "Level identifier must match the attempt domain and difficulty"
      });
    }
  }) satisfies z.ZodType<AttemptResult>;

export const attemptResultsSchema = z
  .array(attemptResultSchema)
  .refine((attempts) => hasUniqueValues(attempts.map(({ id }) => id)), {
    message: "Attempt identifiers must be unique"
  });
